
/**
 * **効果の発動**（Issue #537）。カットイン。
 *
 * 開く: `chaining`。カードを画面の中央に大きく出し、光の帯を走らせる。
 * **チェーンの札**（処理の順番を示すもの）は `chain_solving` が置き、`chain_end` が消す
 * —— **1 ファイル = 1 イベント**なので、開く側と閉じる側が別のファイルになる。
 */
const COLOR = '#ff8fd0';

/** 状況ごとのファイル（`../effects/chaining_<variant>_effect.js`）が共有する組み立て（Issue #628。arcade はどの状況も同じ絵） */
export const spec = {
  label: '効果の発動',
  color: COLOR,
  sounds: () => [{ at: 0, name: 'effect' }],

  opens({ payload }) {
    return payload?.code || payload?.uid ? payload : null;
  },

  layers: [
    {
      id: 'band',
      label: '光の帯',
      part: 'beam',
      at: { screen: [960, 540] },
      props: { color: COLOR, core: 0.3 },
      tf: {
        scale: { keys: [{ ms: 0, value: 0.2 }, { ms: 200, value: 1, ease: 'ease_out' }, { ms: 900, value: 1 }, { ms: 1060, value: 0.2 }] },
        opacity: { keys: [{ ms: 0, value: 0 }, { ms: 160, value: 0.9 }, { ms: 900, value: 0.9 }, { ms: 1060, value: 0 }] },
      },
    },
    {
      id: 'card',
      label: 'カードのカットイン',
      part: 'card',
      parent: 'band',
      props: { code: '{code}', player: '{player}', glow: COLOR, glowW: 6 },
      tf: {
        scale: { keys: [{ ms: 120, value: 0.3 }, { ms: 360, value: 0.58, ease: 'ease_out' }, { ms: 900, value: 0.56 }] },
        opacity: { keys: [{ ms: 120, value: 0 }, { ms: 280, value: 1 }, { ms: 880, value: 1 }, { ms: 1000, value: 0 }] },
        x: { keys: [{ ms: 120, value: -160 }, { ms: 360, value: 0, ease: 'ease_out' }] },
      },
    },
  ],
};
